/* istanbul ignore file */
import React from 'react';
import InputList from './InputList/InputList';
import TextInput from './TextInput';
import { InputListProps } from './InputList/InputList';

const EmailListInput = (props: Omit<InputListProps, 'inputTemplate'>) => {
  return <InputList {...props} inputTemplate={TextInput} addText="Add email" />;
};

export default EmailListInput;
